import { render, staticRenderFns } from "./foodAndBeverages.vue?vue&type=template&id=98cd163c&scoped=true&"
import script from "./foodAndBeverages.vue?vue&type=script&lang=js&"
export * from "./foodAndBeverages.vue?vue&type=script&lang=js&"
import style0 from "./foodAndBeverages.vue?vue&type=style&index=0&id=98cd163c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cd163c",
  null
  
)

export default component.exports